import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPuzzle16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconPuzzle16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.12 4.6H3.5a.5.5 0 0 0-.5.5v7.4a.5.5 0 0 0 .5.5h1.66v-.56a2.04 2.04 0 1 1 4.08 0V13h1.66a.5.5 0 0 0 .5-.5V9.88h1.52a1.08 1.08 0 1 0 0-2.16H11.4V5.1a.5.5 0 0 0-.5-.5H8.28V3.08a1.08 1.08 0 1 0-2.16 0zm6.28 7.28v-1h.52a2.08 2.08 0 1 0 0-4.16h-.52V5.1a1.5 1.5 0 0 0-1.5-1.5H9.28v-.52a2.08 2.08 0 0 0-4.16 0v.52H3.5A1.5 1.5 0 0 0 2 5.1v7.4A1.5 1.5 0 0 0 3.5 14h2.66v-1.56a1.04 1.04 0 1 1 2.08 0V14h2.66a1.5 1.5 0 0 0 1.5-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPuzzle16);
